import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { ErrorMessage } from "components";

export const Select = ({
  className = "",
  value = "",
  name = "",
  id = "",
  label = "",
  disabled = false,
  changeHandler,
  options = [],
  required = false,
  hidden = false,
  errorMessage = "",
  labelClass = "",
  ThemeColor,
  activity,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [filteredOptions, setFilteredOptions] = useState(options);
  const wrapperRef = useRef(null);

  const selectedOption = options.find(
    (item) => item.value === value || item.id === value
  );

  useEffect(() => {
    setFilteredOptions(
      options.filter((item) =>
        (item.name || item.label)
          .toLowerCase()
          .includes(search.toLowerCase())
      )
    );
  }, [search, options]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
        setSearch("");
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleOptionSelect = (option) => {
    changeHandler({ target: { name, value: option.value || option.id } });
    setIsOpen(false);
    setSearch("");
  };

  return (
    <div className="select_field relative" ref={wrapperRef}>
      {label && !hidden && (
        <div className="mb-1">
          <label
            htmlFor={name}
            className={`text-xs paragraphs_font ${activity ? "text-black" : labelClass || (ThemeColor ? "text-black" : "text-white")}`}
          >
            {label}
            {required && <span className="text-red-500 ml-1">*</span>}
          </label>
        </div>
      )}

      <div
        className={`relative w-full ${disabled ? "pointer-events-none opacity-60" : ""}`}
      >
        <div
          className={`w-full border px-3 py-2 rounded-md bg-white cursor-pointer ${className}`}
          onClick={() => !disabled && setIsOpen(!isOpen)}
        >
          {selectedOption?.name || selectedOption?.label || "Select..."}
        </div>

        {isOpen && (
          <div className="absolute z-10 mt-1 w-full bg-white border max-h-64 overflow-auto rounded-md shadow-lg">
            <div className="p-2 border-b">
              <input
                type="text"
                placeholder="Search..."
                className="w-full px-2 py-1 border rounded text-sm text-black"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
            <ul>
              {filteredOptions.length > 0 ? (
                filteredOptions.map((item, index) => (
                  <li
                    key={index}
                    className="px-3 py-2 hover:bg-gray-100 cursor-pointer text-sm text-black"
                    onClick={() => handleOptionSelect(item)}
                  >
                    {item.name || item.label}
                  </li>
                ))
              ) : (
                <li className="px-3 py-2 text-gray-500 text-sm">No options found</li>
              )}
            </ul>
          </div>
        )}
      </div>

      {errorMessage && (
        <span>
          <ErrorMessage message={errorMessage} />
        </span>
      )}
    </div>
  );
};

Select.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string,
  id: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  required: PropTypes.bool,
  changeHandler: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  errorMessage: PropTypes.string,
  hidden: PropTypes.bool,
  labelClass: PropTypes.string,
  ThemeColor: PropTypes.bool,
  activity: PropTypes.bool,
};
